import { Button } from '@/components/ui/button';
import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import dayjs from 'dayjs';
import { useNavigateToDate } from '../../../hooks/useNavigateToDate';
import { YearMonthParams } from '@/domain/termine/type';
import { YearMonthPopoverMobile } from '@/domain/termine/components/YearMonthPicker/mobile/YearMonthPopoverMobile';

export function YearMonthPickerMobile({
  currentMonthAndYear,
}: {
  currentMonthAndYear: YearMonthParams;
}) {
  const switchToDate = useNavigateToDate();
  const monthYearName = currentMonthAndYear.year + currentMonthAndYear.month;
  const prevMonth = dayjs(monthYearName).subtract(1, 'month');
  const nextMonth = dayjs(monthYearName).add(1, 'month');

  const handlePrevMonth = () => switchToDate(prevMonth);
  const handleNextMonth = () => switchToDate(nextMonth);

  return (
    <div className="flex w-full items-center justify-between gap-2 bg-white p-2">
      <Button
        onClick={handlePrevMonth}
        variant="icon"
        size="icon"
        className="text-neutrals-N700 text-xl">
        <FontAwesomeIcon icon={faChevronLeft} />
      </Button>
      <div className="flex items-center justify-center flex-1">
        <YearMonthPopoverMobile />
      </div>
      <Button
        onClick={handleNextMonth}
        className="text-neutrals-N700 text-xl"
        size="icon"
        variant="icon">
        <FontAwesomeIcon icon={faChevronRight} />
      </Button>
    </div>
  );
}
